import { Chip, User as UserIcon, Text, NotificationBanner } from '~components';
import { ListCheck } from '..';
import * as Styled from './styled';
import mobile from 'is-mobile';
import { useTheme } from 'styled-components';
import { SendSMSButton } from '..';
import { formStatusNameMap, formStatusTypeMap } from './utils';

import { Props } from './types';

function PersonInformation({
  id,
  name,
  type,
  status,
  showChecklistIncolumns = false,
  showChecklist,
  canSendSMS,
  documents,
}: Props) {
  const isMobile = mobile();
  const theme = useTheme();

  return (
    <Styled.Wrapper>
      <Styled.Header>
        <Styled.HeaderSection>
          <UserIcon color={theme.color.icon.neutral.strong} />
          <Text variant="sub500">
            {type === 'representative' ? 'Representante legal' : 'Cônjuge'}
          </Text>
        </Styled.HeaderSection>

        <Styled.HeaderSection>
          <Text
            variant={isMobile ? 'b400-bold' : 'h500'}
            color="neutral-strong"
          >
            {name}
          </Text>
        </Styled.HeaderSection>

        <Styled.HeaderSection>
          <Chip type={formStatusTypeMap(status)}>
            {formStatusNameMap(status)}
          </Chip>
        </Styled.HeaderSection>
      </Styled.Header>

      {showChecklist && (
        <>
          <div>
            <ListCheck
              type={type}
              showIncolumns={showChecklistIncolumns}
              status={status}
              documents={documents}
            />
          </div>

          {canSendSMS && (
            <div>
              <SendSMSButton id={id} type={type} />
            </div>
          )}

          {status === 'retake-selfie' && (
            <div>
              <NotificationBanner title="É necessário refazer a foto do rosto (selfie). Clique em reenviar SMS para refazer." />
            </div>
          )}
        </>
      )}
    </Styled.Wrapper>
  );
}

export default PersonInformation;
